import { inject, Injectable } from '@angular/core';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../graphql.module';
import { Apollo } from 'apollo-angular';
import { QuoteRequestRecipientFilterInput, Uuid } from '../../../../graphql';
import { GetQuoteRequestRecipientsV2 } from './queries/GetQuoteRequestRecipients.generated';

@Injectable({
    providedIn: 'root',
})
export class QuoteRequestRecipientApiService {
    #apollo = inject(Apollo);

    private get gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    getSelectedRecipientByQuoteRequestId(quoteRequestId: Uuid) {
        const take = 1;
        const skip = 0;
        const where: QuoteRequestRecipientFilterInput = {
            iD_QuoteRequest: { eq: quoteRequestId },
            isSelectedQuote: { eq: true },
        };
        return this.gql.query({
            query: GetQuoteRequestRecipientsV2,
            variables: {
                take,
                skip,
                where,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    getFirstSelectedRecipientForEstimate(estimateId: Uuid) {
        const take = 1;
        const skip = 0;
        const where: QuoteRequestRecipientFilterInput = {
            isSelectedQuote: { eq: true },
            quoteRequest: {
                iD_Estimate: { eq: estimateId },
                quoteRequestItems: { any: true },
            },
        };
        return this.gql.query({
            query: GetQuoteRequestRecipientsV2,
            variables: {
                take,
                skip,
                where,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    getFirstSelectedRecipientForEstimateAndItems(estimateId: Uuid, estimateItems: [Uuid]) {
        const take = 1;
        const skip = 0;
        const where: QuoteRequestRecipientFilterInput = {
            isSelectedQuote: { eq: true },
            quoteRequest: {
                iD_Estimate: { eq: estimateId },
                quoteRequestItems: { some: { iD_EstimateItem: { in: estimateItems } } },
            },
        };
        return this.gql.query({
            query: GetQuoteRequestRecipientsV2,
            variables: {
                take,
                skip,
                where,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
